export const SECTION_MARGIN_STYLE = { margin: '0.875rem' } as const;

export const SCROLL_CARD_STYLE = {
  maxHeight: '8rem',
  overflow: 'auto'
} as const;

export const SOURCE_CONTENT_STYLE = {
  overflow: 'auto',
  width: '100%'
} as const;
